import { BasketItemModel } from 'models/Basket';
import { routes } from 'routes';
import { appConfig } from '../configurations';

export function goToExternalUrl(url: string) {
    window.location.href = url;
}

export function generateSofaLink(basketItem: BasketItemModel) {
    const isAccessory = Boolean(basketItem.product?.name);

    return isAccessory ? '/accessories' : `/sofas/${basketItem.range?.replace(' ','-')}`;
}

export function getRootLink(): string {
    return '/';
}

export function generateCharityImgPath(id: number | string, imgSize?: string): string {
    return `https://s3-eu-west-1.amazonaws.com/penniesfoundation/charities/${id}-${imgSize ?? '100'}.png`;
}

export const SOFASHIELD_URL = 'https://www.sofology.co.uk/sofology/sofashield';
export const TERMS_AND_CONDITIONS_URL = 'https://www.sofology.co.uk/terms-and-conditions';

export function generateForgotPasswordUrl(basketId: string): string {
    return `${appConfig.forgotPasswordBaseUrl}/ForgotPassword?returnUrl=${generateExternalUrlByPath(routes.deliveryDetails.path)}?basketId=${basketId}`;
}

export function generateExternalUrlByPath(path: string): string {
    return `${window.location.protocol}//${getHostName()}${path}`;
}

export function getCurrentLocation(): string {
    return window.location.href;
}

export function getHostName(): string {
    const port = window.location.port;

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return window.location.hostname + ((port && Number(port) !== 80 && Number(port) !== 443) ? ':' + port : '');
}